module.exports = __webpack_public_path__ + "img/demo.2854cb40.webp";